import React, { useState } from "react";
import { XIcon } from "@heroicons/react/outline";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import Dialog from "@/ui/Dialog";
import { IconButton } from "@/ui/IconButton";
import PurpleDoorLogoHorizontal from "../Logo/PurpleDoorLogoHorizontal";
import Button from "@/ui/Button";

// Import all help option components
import SearchCommunityHelp from "./options/SearchCommunityHelp";
import UnderstandingRequirementsHelp from "./options/UnderstandingRequirementsHelp";
import LowIncomeHousingHelp from "./options/LowIncomeHousingHelp";
import CaseworkerReferralHelp from "./options/CaseworkerReferralHelp";
import CommunitySignupHelp from "./options/CommunitySignupHelp";
import AskQuestionHelp from "./options/AskQuestionHelp";
import JobInquiryHelp from "./options/JobInquiryHelp";

const HelpDialog = ({ open, setOpen }) => {
    const [selectedOption, setSelectedOption] = useState(null);

    const handleClose = () => {
        setOpen(false);
        setSelectedOption(null);
    };

    const handleBack = () => {
        setSelectedOption(null);
    };

    const helpOptions = [
        { id: 1, text: "Help me find a community", component: SearchCommunityHelp },
        {
            id: 2,
            text: "Help me understand my options",
            component: UnderstandingRequirementsHelp,
        },
        { id: 3, text: "Low-Income Housing Assistance", component: LowIncomeHousingHelp },
        {
            id: 4,
            text: "Caseworker with a Patient Referral",
            component: CaseworkerReferralHelp,
        },
        { id: 5, text: "Help me manage my community", component: CommunitySignupHelp },
        { id: 6, text: "Ask a question", component: AskQuestionHelp },
        //{ id: 7, text: "Job inquiry with a community", component: JobInquiryHelp },
    ];

    const SelectedComponent = selectedOption
        ? helpOptions.find((opt) => opt.id === selectedOption)?.component
        : null;

    return (
        <div>
            <Dialog
                open={open}
                className="fixed inset-0 z-50 overflow-y-auto"
                onClose={handleClose}
            >
                <div className="min-h-screen px-4 text-center">
                    <Dialog.Overlay className="fixed -z-10 inset-0 bg-black opacity-70" />

                    <span className="inline-block h-screen align-middle" aria-hidden="true">
                        &#8203;
                    </span>

                    <div
                        className={`inline-block w-full max-w-lg pb-8 overflow-hidden
                                text-left align-middle transition-all transform 
                                bg-white shadow-xl rounded-2xl`}
                    >
                        <Dialog.Title className="px-4 py-2 flex justify-between items-center bg-primary-500">
                            <div className="flex justify-center flex-grow items-center space-x-4">
                                <h3 className="text-2xl font-bold font-headline text-white">
                                    FREE Assistance
                                </h3>
                            </div>
                            <IconButton onClick={handleClose}>
                                <XIcon className="w-8 h-8 p-1 text-white hover:bg-primary-400 rounded-full" />
                            </IconButton>
                        </Dialog.Title>

                        <div>
                            {selectedOption ? (
                                <div className="px-8 pt-6 flex flex-col gap-4">
                                    {SelectedComponent && <SelectedComponent />}

                                    <div className="flex">
                                        <Button
                                            onClick={handleBack}
                                            className="flex items-center bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg"
                                        >
                                            <ArrowLeftIcon className="w-4 h-4 mr-2" /> Back
                                            to options
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <div className="px-8 pb-6">
                                    <div className="flex justify-center mt-4 scale-90">
                                        <PurpleDoorLogoHorizontal />
                                    </div>

                                    <h4 className="text-xl font-semibold my-6">
                                        How can we help? &nbsp; We're here to support you.
                                    </h4>

                                    <div className="space-y-3">
                                        {helpOptions.map((option) => (
                                            <Button
                                                key={option.id}
                                                onClick={() => setSelectedOption(option.id)}
                                                className="w-full text-left bg-gray-100 hover:bg-gray-200 px-4 py-3 rounded-lg"
                                            >
                                                {option.text}
                                            </Button>
                                        ))}

                                        <div className="border-t border-gray-200 pt-3">
                                            <button
                                                onClick={handleClose}
                                                className="w-full text-center text-white bg-green-600 hover:bg-green-700 px-4 py-3 rounded-lg"
                                            >
                                                I'll continue exploring on my own
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default HelpDialog;
